import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getOrders } from '../../store/actions/order/order.action';
import OrdersList from '../../components/Orders/Orders';
import PageLoader from '../../components/Common/PageLoader';

const OrdersContainer = () => {
  // Redux hooks
  const dispatch = useDispatch();

  // Redux state
  const orders = useSelector((state) => state.order.list);
  const isFetching = useSelector((state) => state.order.isFetching);
  const categories = useSelector((state) => state.auth.categories);

  // Local state
  const [mode, setMode] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);

  // Set access based on categories
  const setAccess = useCallback(() => {
    try {
      const orderCategory = categories.find((category) => category.link === 'orders');
      if (orderCategory) {
        setMode(orderCategory.mode);
        setAccessDenied(false);
      } else {
        throw new Error('Order category not found');
      }
    } catch (err) {
      setAccessDenied(true);
    }
  }, [categories]);

  // Initialize on mount
  useEffect(() => {
    dispatch(getOrders());
    setAccess();
  }, [dispatch, setAccess]);

  // Update access when categories change
  useEffect(() => {
    setAccess();
  }, [categories, setAccess]);

  // Loading state
  if (isFetching) {
    return <PageLoader />;
  }

  // Access denied state
  if (accessDenied) {
    return <div>This category is not accessible to the logged in user.</div>;
  }

  // Prepare order info object
  const orderInfo = { orders };

  return (
    <section>
      <OrdersList mode={mode} orderInfo={orderInfo} />
    </section>
  );
};

export default OrdersContainer;
